import classNames from "classnames";

export interface HeaderProps {
  className?: string;
  children?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = (props) => {
  return (
    <div className={classNames(`ucl-header`, props.className)}>
      <div className="ucl-header-children">{props.children}</div>
    </div>
  );
};

export default Header;
